import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ProductIdEnum } from 'outshared-lib';
import { BreadcrumbService } from '../../../core/services/breadcrumb.service';
import { AppRoutesEnum } from '../../../routes';
import * as layoutActions from '../../../store/actions/layout.actions';
import * as fromRoot from '../../../store/app.reducer';

@Component({
    selector: 'ins-verzekeringen-page-hema',
    templateUrl: 'verzekeringen-page-hema.component.html',
    styleUrls: ['./verzekeringen-page-hema.component.scss'],
})

export class VerzekeringenPageHemaComponent implements OnInit {
    public productIdEnum = ProductIdEnum;
    public appRoutesEnum = AppRoutesEnum;

    constructor(
        private store: Store<fromRoot.State>,
    ) {
    }

    ngOnInit(): void {
        this.store.dispatch(new layoutActions.SetBreadcrumb([
            BreadcrumbService.HOME,
            { title: 'Verzekeringen' },
        ]));
    }
}
